


































































































































































































import { Mixins } from "vue-mixin-decorator";
import { Component } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import GeneralMixin from "@/mixin";
import { ISelectItem } from "@/types";
import { ICost, ICostCreateRequest, ICostUpdateRequest } from "@/types/cost";
import { ICategory, ICategoryListRequest } from "@/types/category";
import { ICostIndex } from "@/types/cost_index";
import { IPartnerListRequest } from "@/types/partner";
import { ICostIndexListRequest } from "@/types/cost_index";

@Component({
  components: {}
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("cost/get")
  public getCost!: (id: number) => void;

  @Action("category/getList")
  public getCategoryList!: (params: ICategoryListRequest) => boolean;

  @Action("partner/getList")
  public getPartnerList!: (params: IPartnerListRequest) => boolean;

  @Action("cost_index/getList")
  public getCostIndexList!: (params: ICostIndexListRequest) => boolean;

  @Action("cost/create")
  public create!: (params: ICostCreateRequest) => boolean;

  @Action("cost/update")
  public update!: (data: {
    cost_id: number;
    params: ICostUpdateRequest;
  }) => boolean;

  @Action("cost/delete")
  public deleteCost!: (cost_id: number) => boolean;

  @Getter("cost/single")
  public cost!: ICost;

  @Getter("cost_index/selectItem")
  public cost_indices!: ISelectItem[];

  @Getter("cost_index/find")
  public cost_find!: (cost_index_id: number) => ICostIndex;

  @Getter("category/selectItem")
  public categories!: ISelectItem[];

  @Getter("category/find")
  public findCategory!: (category_id: number) => ICategory;

  @Getter("partner/selectItem")
  public partners!: ISelectItem[];

  @Getter("partner/filterdSelectItem")
  public filterdPartnerSelectItem!: (category_id: number) => ISelectItem[];

  @Mutation("cost/clear")
  public clear!: () => void;

  @Mutation("partner/clear")
  public clearPartner!: () => void;

  @Mutation("cost_index/clear")
  public clearCostIndex!: () => void;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public $vuetify: any;

  public site_id = 0;
  public cost_id = 0;

  public valid = true;
  public lazy = false;
  public dialog = false;

  public rules = {
    name: [
      (v: string) => !!v || "現場名は必須です",
      (v: string) =>
        (v && v.length <= 30) || "現場名は30文字以下で入力してください"
    ],

    accounted_at: [(v: string) => !!v || "日付は必須です"],
    category_id: [(v: string) => !!v || "発注カテゴリは必須です"],
    partner_id: [(v: string) => !!v || "発注先は必須です"],
    cost_index_id: [(v: string) => !!v || "内容は必須です"],
    value: [
      (v: string) => !!v || "単価は必須です",
      (v: string) =>
        /^[1-9]+[0-9]*$/.test(v) || "単価は半角数字で1以上を入力してください"
    ],
    volume: [
      (v: string) => !!v || "数量は必須です",
      (v: string) =>
        /^([1-9]\d*|0)(\.\d+)?$/.test(v) ||
        "数量は半角数字で0より大きい数を入力してください"
    ]
    // unit: [(v: string) => !!v || "単位は必須です"]
  };

  public params: ICostCreateRequest = {
    name: "",
    volume: null,
    value: null,
    unit: "",
    memo: "",
    site_id: 0,
    partner_id: 0,
    category_id: 0,
    cost_index_id: 0,
    accounted_at: "",
    upload_file: "",
    required_image: false
  };

  public menu = {
    accounted_at: false,
    partner: false,
    cost_index: false
  };

  public image_url = "";

  //--------
  // コンポーネント作成時実行
  public async created() {
    this.site_id = this.params.site_id = Number(this.$route.params.site_id);
    this.cost_id = Number(this.$route.params.cost_id);
    this.clear();
    this.clearPartner();
    this.clearCostIndex();

    // 新規作成
    if (!this.cost_id) {
      this.getCategoryList({ per_page: 0 });
      return;
    }

    // 更新
    await Promise.all([
      this.getCategoryList({ per_page: 0 }),
      this.getCost(this.cost_id)
    ]);
    this.setDefault();
    if (this.cost.category_id) {
      await this.getPartnerList({
        category_id: this.cost.category_id,
        per_page: 0
      });
      if (this.partners.length > 0) {
        this.menu.partner = true;
      }
    }

    if (this.cost.partner_id) {
      await this.getCostIndexList({
        partner_id: this.cost.partner_id,
        per_page: 0
      });
      if (this.cost_indices.length > 0) {
        this.menu.cost_index = true;
        return;
      }
    }
  }

  //--------
  // 更新時デフォルト値をセットする
  private setDefault() {
    this.params.name = this.cost.name;
    this.params.volume = this.cost.volume;
    this.params.value = this.cost.value;
    this.params.unit = this.cost.unit;
    this.params.memo = this.cost.memo;
    this.params.site_id = this.cost.site_id;
    this.params.partner_id = this.cost.partner_id;
    this.params.category_id = this.cost.category_id;
    this.params.cost_index_id = this.cost.cost_index_id;
    this.params.accounted_at = this.date_format(this.cost.accounted_at);
  }

  //--------
  // 合計を自動計算
  public get amount() {
    if (this.params.value && this.params.volume) {
      return this.price_format(this.params.value * this.params.volume);
    }
    return 0;
  }

  //--------
  // ファイルが選択されたときの挙動
  public fileChanged(event: Event) {
    const $file = event.target as HTMLInputElement;
    const files = $file.files || [];
    if (files.length === 0) {
      return;
    }

    const file = files[0];
    if (!/^image/.test(file.type)) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      this.params.upload_file = reader.result as string;
      this.image_url = reader.result as string;
    };
  }

  //--------
  // カテゴリが選択された際、
  // 適切な選択項目を用意する
  public async categorySelected() {
    this.params.partner_id = 0;
    this.params.cost_index_id = 0;
    this.menu.partner = false;
    this.menu.cost_index = false;

    await this.getPartnerList({
      category_id: this.params.category_id,
      per_page: 0
    });
    if (this.partners.length > 0) {
      this.menu.partner = true;
    }
  }

  //--------
  // 発注先が選択された際、
  // 適切な選択項目を用意する
  public async partnerSelected() {
    this.params.cost_index_id = 0;
    this.menu.cost_index = false;

    await this.getCostIndexList({
      partner_id: this.params.partner_id,
      per_page: 0
    });
    if (this.cost_indices.length > 0) {
      this.menu.cost_index = true;
      return;
    }
  }

  //--------
  // 内容が選択された際、
  // 価格のデフォルト値をセットする
  public costindexSelected() {
    const costindex = this.cost_find(this.params.cost_index_id);
    this.params.value = costindex.value || null;
  }

  //--------
  // 確定ボタンが押された際の挙動
  // 更新時と作成時で問合せ先が違う
  public async submit() {
    if (!this.cost_id) {
      return await this.create(this.params);
    }

    return await this.update({
      cost_id: this.cost_id,
      params: this.params
    });
  }

  public async submitAndReset() {
    const result = await this.submit();
    if (result) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const form: any = this.$refs.form;
      form.reset();
      this.$vuetify.goTo(0);
    }
  }

  public async submitAndContinue() {
    const result = await this.submit();
    if (result) {
      this.$vuetify.goTo(0);
    }
  }

  public async submitAndBack() {
    const result = await this.submit();
    if (result) {
      this.$router.go(-1);
    }
  }

  //--------
  // 削除確認画面
  public destroyConfirm() {
    this.dialog = true;
  }

  //--------
  // 削除実行
  public async destroy() {
    this.dialog = false;
    if (await this.deleteCost(this.cost_id)) {
      this.$router.go(-1);
    }
  }
}
